module.exports = __webpack_public_path__ + "static/media/golfer-5-b.a2c017a3.png";